export function formatCurrency(amount: number, locale: string, currency = "EGP") {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(amount);
}
